(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dac-care-policy"]) return;
  try {
    
(() => {
  const initialize = () => {
    const root = document.getElementById('dac-care');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const markCurrent = () => {
      root.querySelectorAll('.dac-care-topic-list a').forEach(link => {
        if (link.hash === location.hash) link.setAttribute('aria-current','location');
        else link.removeAttribute('aria-current');
      });
    };
    root.addEventListener('click', event => {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;
      const menu = link.closest('.dac-care-mobile-nav');
      if (menu) menu.open = false;
    });
    window.addEventListener('hashchange',markCurrent);
    markCurrent();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize);
  else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dac-help-hero"]) return;
  try {
    
  (() => {
    const initialize = () => {
      const root = document.getElementById('dac-help');
      if (!root || root.dataset.ready) return;
      root.dataset.ready = 'true';
      const input = root.querySelector('#dac-help-query');
      const clear = root.querySelector('.dac-help-clear');
      const status = root.querySelector('#dac-help-results');
      const main = root.closest('main');
      const groups = Array.from(main.querySelectorAll('.dac-help-group'));
      const questions = Array.from(main.querySelectorAll('.dac-help-question'));
      const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^\p{L}\p{N}]+/gu,' ').trim();
      const records = questions.map(element => ({element, text: normalize(element.closest('.dac-help-group').querySelector('h2').textContent + ' ' + element.textContent)}));
      let searching = false;
      let savedOpen = new Set();
      let timer;
      const filter = () => {
        const query = normalize(input.value);
        const tokens = query.split(' ').filter(Boolean);
        if (query && !searching) savedOpen = new Set(questions.filter(element => element.open));
        let count = 0;
        records.forEach(({element,text}) => {
          const matches = tokens.every(token => text.includes(token));
          element.hidden = !matches;
          if (query) element.open = matches;
          else if (searching) element.open = savedOpen.has(element);
          if (matches) count++;
        });
        let visibleGroups = 0;
        groups.forEach(group => {
          const visible = Array.from(group.querySelectorAll('.dac-help-question')).some(element => !element.hidden);
          group.closest('.dac-help-group-section').hidden = !visible;
          if (visible) visibleGroups++;
        });
        const navigation = main.querySelector('.dac-help-nav-section');
        navigation.hidden = count === 0;
        navigation.style.setProperty('--help-visible-groups',String(visibleGroups));
        searching = Boolean(query);
        clear.hidden = !input.value;
        status.textContent = !query ? '' : count === 0 ? status.dataset.none : (count === 1 ? status.dataset.one : status.dataset.many).replace('[count]',String(count));
      };
      const reset = focus => { clearTimeout(timer); input.value = ''; filter(); if (focus) input.focus(); };
      input.addEventListener('input',() => { clearTimeout(timer); timer = setTimeout(filter,120); });
      input.addEventListener('keydown',event => { if (event.key === 'Escape') { event.preventDefault(); reset(true); } if (event.key === 'Enter') { event.preventDefault(); clearTimeout(timer); filter(); } });
      clear.addEventListener('click',() => reset(true));
      main.addEventListener('click',event => {
        const link = event.target.closest('a[href^="#"]');
        if (!link) return;
        if (input.value) reset(false);
        const target = document.getElementById(link.hash.slice(1));
        if (target?.matches('.dac-help-question')) target.open = true;
        const mobile = link.closest('.dac-help-mobile-topics');
        if (mobile) mobile.open = false;
      });
      const revealHash = () => {
        let id;
        try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
        const target = document.getElementById(id);
        if (!target || !main.contains(target)) return;
        if (searching) reset(false);
        if (target.matches('.dac-help-question')) target.open = true;
        const group = target.closest('.dac-help-group');
        main.querySelectorAll('.dac-help-topic-list a').forEach(link => {
          if (group && link.hash === '#' + group.id) link.setAttribute('aria-current','location');
          else link.removeAttribute('aria-current');
        });
      };
      window.addEventListener('hashchange',revealHash);
      root.querySelector('.dac-help-search').hidden = false;
      revealHash();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize);
    else initialize();
    document.addEventListener('shopify:section:load',initialize);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dac-return-policy"]) return;
  try {
    
(() => {
  const initialize = () => {
    const root = document.getElementById('dac-returns');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const markCurrent = () => {
      root.querySelectorAll('.dac-returns-topic-list a').forEach(link => {
        if (link.hash === location.hash) link.setAttribute('aria-current','location');
        else link.removeAttribute('aria-current');
      });
    };
    root.addEventListener('click', event => {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;
      const menu = link.closest('.dac-returns-mobile-nav');
      if (menu) menu.open = false;
    });
    window.addEventListener('hashchange',markCurrent);
    markCurrent();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize);
  else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dac-shipping-policy"]) return;
  try {
    
(() => {
  const initialize = () => {
    const root = document.getElementById('dac-shipping');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const markCurrent = () => {
      root.querySelectorAll('.dac-shipping-topic-list a').forEach(link => {
        if (link.hash === location.hash) link.setAttribute('aria-current','location');
        else link.removeAttribute('aria-current');
      });
    };
    root.addEventListener('click', event => {
      const link = event.target.closest('a[href^="#"]');
      if (!link) return;
      const menu = link.closest('.dac-shipping-mobile-nav');
      if (menu) menu.open = false;
    });
    window.addEventListener('hashchange',markCurrent);
    markCurrent();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize);
  else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();

  } catch(e) { console.error(e); }
})();
})();
